import React from 'react'
import { UIStyledInner, UIStyledWrapper } from './sectionContainer.style'

interface SectionContainerProps {
  children?: React.ReactNode
}

/**
 * @deprecated use SectionContainer from src/components/v2/atoms/section-container/section-container.tsx
 */
const SectionContainer = ({ children }: SectionContainerProps) => {
  return (
    <UIStyledWrapper>
      <UIStyledInner>{children}</UIStyledInner>
    </UIStyledWrapper>
  )
}

export default SectionContainer
